import React from 'react';
import { TabProps } from '../types';
import { Icon, Header, Grid } from 'semantic-ui-react';
import { DesignSystem } from '../../../styles/designSystem';

const FiscalTab: React.FC<TabProps> = ({ data }) => {
  return (
    <div style={{
      padding: '1rem',
      background: DesignSystem.colors.section.gradient,
      minHeight: '30vh'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '10px',
        padding: '1rem',
        boxShadow: '0 8px 15px rgba(0,0,0,0.08)',
        border: '1px solid rgba(255,255,255,0.8)'
      }}>
        <Header as="h2" style={{
          color: '#2c3e50',
          textAlign: 'center',
          marginBottom: '1rem',
          fontWeight: '700',
          fontSize: '1.3rem'
        }}>
          <div style={{
            background: 'linear-gradient(135deg, #f39c12, #e67e22)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            display: 'inline-block'
          }}>
            <Icon name="calculator" size="large" />
            Dados Fiscais
          </div>
        </Header>

        <div style={{
          background: 'linear-gradient(135deg, #f39c12, #e67e22)',
          borderRadius: '15px',
          padding: '2rem',
          marginBottom: '2rem',
          color: 'white',
          textAlign: 'center',
          boxShadow: '0 15px 35px rgba(243, 156, 18, 0.3)'
        }}>
          <Icon name="chart line" size="huge" />
          <Header as="h3" style={{ color: 'white', margin: '1rem 0' }}>
            Informações Fiscais e Tributárias
          </Header>
          <p style={{ color: 'rgba(255,255,255,0.8)', margin: 0, fontSize: '1.1rem' }}>
            Regime tributário e informações fiscais da empresa
          </p>
        </div>

        <Grid columns={2} stackable>
          {/* Simples Nacional */}
          <Grid.Column>
            <div style={{
              background: 'linear-gradient(135deg, #27ae60, #229954)',
              borderRadius: '15px',
              padding: '2rem',
              height: '100%',
              color: 'white',
              boxShadow: '0 15px 35px rgba(39, 174, 96, 0.3)',
              border: '1px solid rgba(255,255,255,0.2)'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
                <Icon name="check circle" size="large" />
                <div>
                  <Header as="h3" style={{ color: 'white', margin: 0, fontSize: '1.3rem' }}>
                    Simples Nacional
                  </Header>
                  <p style={{ color: 'rgba(255,255,255,0.8)', margin: '0.25rem 0 0 0' }}>
                    Regime tributário simplificado
                  </p>
                </div>
              </div>

              <div style={{
                background: 'rgba(255,255,255,0.2)',
                borderRadius: '10px',
                padding: '1.5rem',
                backdropFilter: 'blur(10px)'
              }}>
                <div style={{ marginBottom: '1rem' }}>
                  <div style={{ fontSize: '0.9rem', opacity: 0.9, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                    Optante
                  </div>
                  <div style={{ fontSize: '1.4rem', fontWeight: '700' }}>
                    {data.simples?.optante ? '✅ Sim' : '❌ Não'}
                  </div>
                </div>

                {data.simples?.dataOpcao && (
                  <div style={{ marginBottom: '1rem' }}>
                    <div style={{ fontSize: '0.9rem', opacity: 0.9, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                      Data de Opção
                    </div>
                    <div style={{ fontSize: '1.1rem', fontWeight: '600' }}>
                      {data.simples.dataOpcao}
                    </div>
                  </div>
                )}

                {data.simples?.dataExclusao && (
                  <div>
                    <div style={{ fontSize: '0.9rem', opacity: 0.9, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                      Data de Exclusão
                    </div>
                    <div style={{ fontSize: '1.1rem', fontWeight: '600' }}>
                      {data.simples.dataExclusao}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Grid.Column>

          {/* SIMEI */}
          <Grid.Column>
            <div style={{
              background: 'linear-gradient(135deg, #3498db, #2980b9)',
              borderRadius: '15px',
              padding: '2rem',
              height: '100%',
              color: 'white',
              boxShadow: '0 15px 35px rgba(52, 152, 219, 0.3)',
              border: '1px solid rgba(255,255,255,0.2)'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
                <Icon name="building" size="large" />
                <div>
                  <Header as="h3" style={{ color: 'white', margin: 0, fontSize: '1.3rem' }}>
                    SIMEI
                  </Header>
                  <p style={{ color: 'rgba(255,255,255,0.8)', margin: '0.25rem 0 0 0' }}>
                    Microempreendedor Individual
                  </p>
                </div>
              </div>

              <div style={{
                background: 'rgba(255,255,255,0.2)',
                borderRadius: '10px',
                padding: '1.5rem',
                backdropFilter: 'blur(10px)'
              }}>
                <div style={{ marginBottom: '1rem' }}>
                  <div style={{ fontSize: '0.9rem', opacity: 0.9, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                    Optante
                  </div>
                  <div style={{ fontSize: '1.4rem', fontWeight: '700' }}>
                    {data.simei?.optante ? '✅ Sim' : '❌ Não'}
                  </div>
                </div>

                {data.simei?.dataOpcao && (
                  <div style={{ marginBottom: '1rem' }}>
                    <div style={{ fontSize: '0.9rem', opacity: 0.9, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                      Data de Opção
                    </div>
                    <div style={{ fontSize: '1.1rem', fontWeight: '600' }}>
                      {data.simei.dataOpcao}
                    </div>
                  </div>
                )}

                {data.simei?.dataExclusao && (
                  <div>
                    <div style={{ fontSize: '0.9rem', opacity: 0.9, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                      Data de Exclusão
                    </div>
                    <div style={{ fontSize: '1.1rem', fontWeight: '600' }}>
                      {data.simei.dataExclusao}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Grid.Column>
        </Grid>

        {/* Informações Adicionais */}
        {(data.efr || data.ultimaAtualizacao) && (
          <div style={{
            background: 'linear-gradient(135deg, #f8f9fa, #ffffff)',
            borderRadius: '15px',
            padding: '2rem',
            marginTop: '2rem',
            boxShadow: '0 8px 20px rgba(0,0,0,0.05)',
            border: '1px solid rgba(243, 156, 18, 0.1)'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem' }}>
              <div style={{
                background: 'linear-gradient(135deg, #f39c12, #e67e22)',
                borderRadius: '50%',
                padding: '1rem',
                color: 'white'
              }}>
                <Icon name="clock" size="large" />
              </div>
              <div>
                <Header as="h3" style={{ color: '#2c3e50', margin: 0 }}>
                  Informações Adicionais
                </Header>
                <p style={{ color: '#7f8c8d', margin: '0.25rem 0 0 0' }}>
                  Dados complementares e atualizações
                </p>
              </div>
            </div>

            <Grid columns={2} stackable>
              {data.efr && (
                <Grid.Column>
                  <div style={{
                    background: 'rgba(243, 156, 18, 0.1)',
                    borderRadius: '10px',
                    padding: '1rem',
                    border: '1px solid rgba(243, 156, 18, 0.2)'
                  }}>
                    <div style={{ color: '#7f8c8d', fontSize: '0.9rem', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                      EFR
                    </div>
                    <div style={{ color: '#2c3e50', fontSize: '1.1rem', fontWeight: '500' }}>
                      {data.efr}
                    </div>
                  </div>
                </Grid.Column>
              )}

              {data.ultimaAtualizacao && (
                <Grid.Column>
                  <div style={{
                    background: 'rgba(243, 156, 18, 0.1)',
                    borderRadius: '10px',
                    padding: '1rem',
                    border: '1px solid rgba(243, 156, 18, 0.2)'
                  }}>
                    <div style={{ color: '#7f8c8d', fontSize: '0.9rem', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                      Última Atualização
                    </div>
                    <div style={{ color: '#2c3e50', fontSize: '1.1rem', fontWeight: '500' }}>
                      {data.ultimaAtualizacao}
                    </div>
                  </div>
                </Grid.Column>
              )}
            </Grid>
          </div>
        )}

        {!data.simples && !data.simei && !data.efr && !data.ultimaAtualizacao && (
          <div style={{
            background: 'linear-gradient(135deg, #f8f9fa, #ffffff)',
            borderRadius: '15px',
            padding: '3rem',
            textAlign: 'center',
            boxShadow: '0 8px 20px rgba(0,0,0,0.05)',
            border: '1px solid rgba(243, 156, 18, 0.1)'
          }}>
            <Icon name="calculator" size="huge" style={{ color: '#bdc3c7' }} />
            <Header as="h3" style={{ color: '#7f8c8d', margin: '1rem 0' }}>
              Nenhuma informação fiscal disponível
            </Header>
            <p style={{ color: '#95a5a6', fontSize: '1.1rem' }}>
              Não há informações fiscais disponíveis para este CNPJ.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default FiscalTab;
